import { createSlice } from '@reduxjs/toolkit'
import { GeneralState } from '../state/GeneralState.type'

const initialState: GeneralState = {
    loader: false
}

export const GeneralSlice = createSlice({
    name: "General",
    reducers: {
        loaderStart: (state) => {
            state.loader = true
        },
        loaderStop: (state) => {
            state.loader = false
        }
    },
    initialState
})

export const { loaderStart, loaderStop } = GeneralSlice.actions
export default GeneralSlice.reducer;